import { render, staticRenderFns } from "./jefeszona_M.vue?vue&type=template&id=bdf820f2"
import script from "./jefeszona_M.vue?vue&type=script&lang=js"
export * from "./jefeszona_M.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports